// ***********  Ce composant permet de rendre le tableau de details dans la liste deroulante de l'onglet de tabulation "Depots" *****************
import React from 'react';
import { useState, useEffect } from 'react';

//devExtrem
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import { DataGrid, Column, Editing } from 'devextreme-react/data-grid';

//hooks
import useLoadTypeUnite from './useLoadDataTypeUnite';
import useLookUpBase from '../../components/selectbox/LookupBase';

const MasterDetailGrid = (props: { data: { data: { idTypeUniteDepot: any; }, key: string } }) => {
  const [dataSource, setDataSource] = useState(new DataSource({}));


  const { selectBox: DepotTypeDelaiSelectBox } = useLookUpBase({ controllerName: "TypeUniteDepotTypeDelai" });

  const { _getDataSourceDepotDetails } = useLoadTypeUnite(null);

  useEffect(() => {
    setDataSource(getDetails(props.data.data.idTypeUniteDepot));
  }, [props.data.data.idTypeUniteDepot]);


  function getDetails(key: any) {
    return new DataSource({
      store: new ArrayStore({
        data: _getDataSourceDepotDetails(),
        key: 'idTypeUnite',
      }),
      filter: ['idTypeUniteDepotParent', '=', key],
    });
  }
  return (
    <React.Fragment>
      <DataGrid
        keyExpr="idTypeUnite"
        dataSource={dataSource}
        showBorders={true}
      >
        <Column dataField="numeroDepot" dataType="number" caption="N. dépôt" alignment={'left'} allowEditing={false} />
        <Column dataField="description" dataType="string" caption="Description" />
        <Column dataField="montantDepot" dataType="number" caption="Montant ou %" alignment={'left'} />
        <Column dataField="montantDepotMinimum" dataType="number" caption="Montant dépôt minimum" format="currency" alignment={'left'} />
        <Column dataField="typeDelai" dataType="string" caption="Type de délais" cellRender={DepotTypeDelaiSelectBox} />
        <Column dataField="nombreJoursDelai" dataType="number" caption="Nb. jours délai" alignment={'left'} />
        <Column dataField="dateDelai" dataType="date" caption="Date de délais" format={"yyyy-MM-dd"} />
        <Editing
          mode="row"
          allowAdding={true}
          allowDeleting={true}
          allowUpdating={true}
        />

      </DataGrid>
    </React.Fragment>
  )
}


export default MasterDetailGrid